import React, { useRef, useState } from 'react';
import 'cropperjs/dist/cropper.css';
import { Cropper } from 'react-cropper';
import { Modal, Button, ButtonGroup } from 'react-bootstrap';
import { connect, useSelector } from 'react-redux';
import { executeEditImageDownload } from '../../actions/umoGallery';
import { injectIntl } from 'react-intl';
import FlipHorizontal from '../Icons/FlipHorizontal';
import FlipVertical from '../Icons/FlipVertical';
import PenOff from '../Icons/PenOff';
import {
  UMO_MODIFY_TYPE_IMAGE_EDIT_MIRRROR,
  UMO_MODIFY_TYPE_IMAGE_EDIT_ROTATE,
} from '../../constants/umoModifications';

const ImageEditModal = ({ modalData, onModalCloseClick, dispatch, intl }) => {
  const cropperRef = useRef(null);
  const [rotationAngle, setRotationAngle] = useState(0);
  const [isMirroredX, setIsMirroredX] = useState(false);
  const [isMirroredY, setIsMirroredY] = useState(false);
  const csrf = sessionStorage.getItem('token');
  const ANGLE_STEP = 45;
  const isSurlInCookie = useSelector((state) => {
    return state.session.get('surlCookie');
  });
  const surlFromSession = useSelector((state) => {
    return state.session.get('surl');
  });

  const surl = (isSurlInCookie && '') || surlFromSession;

  const umoUrl = modalData.get('umoUrl');
  const umoId = modalData.get('umoId');
  const modalType = modalData.get('modType');

  // Rotate left
  const rotateLeft = () => {
    setRotationAngle((prev) => {
      const newAngle = (prev - ANGLE_STEP + 360) % 360;
      return newAngle;
    });
    const cropper = cropperRef.current.cropper;
    cropper.rotate(-ANGLE_STEP);
  };

  // Rotate right
  const rotateRight = () => {
    setRotationAngle((prev) => (prev + ANGLE_STEP) % 360);
    const cropper = cropperRef.current.cropper;
    cropper.rotate(ANGLE_STEP);
  };

  // Mirror X
  const mirrorX = () => {
    const cropper = cropperRef.current.cropper;
    cropper.scaleX(cropper.getData().scaleX * -1);
    setIsMirroredX((prev) => !prev);
  };

  // Mirror Y
  const mirrorY = () => {
    const cropper = cropperRef.current.cropper;
    cropper.scaleY(cropper.getData().scaleY * -1);
    setIsMirroredY((prev) => !prev);
  };

  // Reset transformations
  const resetTransformations = () => {
    const cropper = cropperRef.current?.cropper;
    if (cropper) cropper.reset().scaleX(0.8).scaleY(0.8);
    setRotationAngle(0);
    setIsMirroredX(false);
    setIsMirroredY(false);
  };

  // Open and close modal handlers
  const handleCloseModal = () => {
    onModalCloseClick();
    resetTransformations();
  };

  // Download the edited image
  const handleDownload = () => {
    const options = {
      rotationAngle: rotationAngle === 0 ? 360 : rotationAngle,
      flipFlops: `${isMirroredX ? '-flop' : ''} ${
        isMirroredY ? '-flip' : ''
      }`.trim(),
    };
    dispatch(executeEditImageDownload(csrf, surl, modalType, umoId, options));
  };

  return (
    <div className="image-edit-modal">
      <Modal.Header closeButton>
        <Modal.Title>
          {intl.formatMessage({
            id:
              modalType == UMO_MODIFY_TYPE_IMAGE_EDIT_ROTATE
                ? 'imageEdit.rotateImage'
                : 'imageEdit.mirrorImage',
          })}
        </Modal.Title>
      </Modal.Header>
      <Modal.Body>
        <div className="edit-container">
          <Cropper
            className="cropper"
            initialAspectRatio={1}
            src={umoUrl}
            ref={cropperRef}
            viewMode={1}
            guides={false}
            autoCrop={false}
            dragMode="move"
            background={false}
            scaleX={0.8}
            scaleY={0.8}
            zoomable={true}
            responsive={true}
            rotatable={true}
            rotateTo={rotationAngle}
            checkOrientation={false}
          />
        </div>
        {modalType == UMO_MODIFY_TYPE_IMAGE_EDIT_ROTATE && (
          <div className="button-group-container">
            <ButtonGroup size="lg" className="mb-2">
              <Button onClick={rotateLeft}>
                <i className="rotate-left-icon" />
              </Button>
              <Button onClick={rotateRight}>
                <i className="rotate-right-icon" />
              </Button>
              <Button onClick={resetTransformations}>
                <PenOff stroke={'white'} width={22} height={22} />
              </Button>
            </ButtonGroup>
          </div>
        )}
        {modalType == UMO_MODIFY_TYPE_IMAGE_EDIT_MIRRROR && (
          <div className="button-group-container">
            <ButtonGroup size="lg" className="mb-2">
              <Button onClick={mirrorX}>
                <FlipHorizontal stroke={'white'} width={22} height={22} />
              </Button>
              <Button onClick={mirrorY}>
                <FlipVertical stroke={'white'} width={22} height={22} />
              </Button>
              <Button onClick={resetTransformations}>
                <PenOff stroke={'white'} width={22} height={22} />
              </Button>
            </ButtonGroup>
          </div>
        )}
      </Modal.Body>
      <Modal.Footer>
        <Button variant="outline" onClick={handleCloseModal}>
          {intl.formatMessage({
            id: 'general.close',
          })}
        </Button>
        <Button variant="primary" onClick={handleDownload}>
          {intl.formatMessage({
            id: 'general.download',
          })}
        </Button>
      </Modal.Footer>
    </div>
  );
};

export default connect()(injectIntl(ImageEditModal));
